import * as React from "react";

import { cn } from "./utils";

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
    'w-full px-4 py-2 bg-input-background border border-border rounded-lg',
    'focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent',
    'disabled:opacity-50 disabled:cursor-not-allowed',
    'overflow-y-auto resize-none',
    className
  )}

      {...props}
    />
  );
}

export { Textarea };
